"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SimulatedKpiValueDTO_1 = require("../model/SimulatedKpiValueDTO");

var SimulatedKpiValueDTOConverter_1 = require("./SimulatedKpiValueDTOConverter");

var SimulatedKpiValueDTOConverterImpl =
/*#__PURE__*/
function (_SimulatedKpiValueDTO) {
  _inherits(SimulatedKpiValueDTOConverterImpl, _SimulatedKpiValueDTO);

  function SimulatedKpiValueDTOConverterImpl() {
    _classCallCheck(this, SimulatedKpiValueDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatedKpiValueDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SimulatedKpiValueDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SimulatedKpiValueDTO_1.SimulatedKpiValueDTO(source.value ? conversions.toBigNumber(source.value) : null, source.affectedBySimulation);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        value: source.value ? conversions.fromBigNumber(source.value) : null,
        affectedBySimulation: source.affectedBySimulation
      };
    }
  }]);

  return SimulatedKpiValueDTOConverterImpl;
}(SimulatedKpiValueDTOConverter_1.SimulatedKpiValueDTOConverter);

exports.SimulatedKpiValueDTOConverterImpl = SimulatedKpiValueDTOConverterImpl;